<template>
  <div style="width: 100%" class="table">
    <vxe-toolbar size="mini" v-if="!isHiddenTopBtn">
      <template v-slot:buttons>
        <template>
          <el-button type="primary" size="small" class="vxe-btn-primary" @click="addNewRowHandler"
            >新增</el-button
          >
          <el-button
            size="small"
            type="danger"
            class="vxe-btn-delete"
            @click="deleteBtnClickHandler"
            >删除</el-button
          >
        </template>
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      border
      auto-resize
      resizable
      show-overflow
      keep-source
      ref="xTableRef"
      class="vxe-table-element"
      size="mini"
      align="left"
      :data="tableData"
      :columns="tableColumnsList"
      :edit-rules="tableRules"
      :edit-config="editConfig"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :show-footer="true"
      :footer-method="footerMethod"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      @edit-closed="closeEditTableHandler"
    >
    </vxe-grid>
    <BusinessDialog ref="businessDialogRef" @updateProduct="updateProduct" />
    <ProductDescDialog ref="productDescDialogRef" />
  </div>
</template>

<script>
  import contractComputedMixin from './../../../contractComputedMixin.js';
  import BusinessDialog from './BusinessDialog';
  import ProductDescDialog from './ProductDescDialog';
  import { formatDate } from '@/utils';
  import API from '@/api/dataBase.js';
  export default {
    name: 'ContractTable',
    mixins: [contractComputedMixin],
    props: {
      detailPageData: {
        type: Object,
        default: () => {},
      },
      isRestrict: {
        type: [Number, String],
      },
      orderDetailList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableData: [],
        tableRules: {
          productDesc: [{ required: true, message: '必填字段' }],
          productQuantity: [{ required: true, message: '必填字段' }],
          businessContractTotalAmount: [{ required: true, message: '必填字段' }],
          // businessContractUnitPrice: [{ required: true, message: '必填字段' }],
          storageName: [{ required: true, message: '必填字段' }],
          isFixedPrice: [{ required: true, message: '必填字段' }],
        },
        editConfig: { trigger: 'click', mode: 'row' },
        selectionList: [],
        isHiddenTopBtn: false,
        isShowVariablePriceIcon: false,
        orderDetailDelIds: [],
        companyList: [],
      };
    },
    computed: {
      tableColumnsList() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '序号', width: 50 },
          { type: 'seq', title: '行项目号', width: 100 },
          {
            field: 'productDesc',
            title: '商品描述',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <div>
                    <span>{row['productDesc']}</span>
                    {this.isShowVariablePriceIcon && row['isFixedPrice'] == '0' && (
                      <i
                        class="el-icon-chat-square icon-btn"
                        onClick={(val) => this.clickProductDetailDialog(val, row, 'productDesc')}
                      ></i>
                    )}
                  </div>,
                ];
              },
              // selectCompanyCode: this.companyCode || this.userInfo.companyCode,
              /**
               * <SearchTable
                    searchType="warehouseCompany"
                    isMultiple={true}
                    currentValue={row['companyName']}
                    checkRowKeys={[row['companyCode']]}
                    onInput={(val) => this.chooseTable(val, row, 'companyName')}
                  ></SearchTable>,
               */
              edit: ({ row }) => {
                return [
                  <SearchTable
                    searchType="usableProduct"
                    isMultiple={true}
                    extraData={{
                      detailProductStatus: 'ZT03',
                      contractCategory: 'purchase',
                      adminFlag: 2,
                      selectCompanyCode: this.companyCode || this.userInfo.companyCode,
                      businessCompanyCodeList: this.companyList,
                    }}
                    currentValue={row['productDesc']}
                    checkRowKeys={[row['productNo']]}
                    onInput={(val) => this.chooseTable(val, row, 'productDesc')}
                  ></SearchTable>,
                ];
              },
            },
          },
          {
            field: 'norms',
            width: 150,
            title: '规格',
            editRender: {
              name: 'ElInput',
              props: {
                disabled: true,
              },
            },
          },
          {
            field: 'stuff',
            width: 150,
            title: '材料',
            editRender: {
              name: 'ElInput',
              props: {
                disabled: true,
              },
            },
          },
          {
            field: 'productQuantity',
            title: '采购数量',
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['productQuantity']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['productQuantity']}
                    max={999999999.999999}
                    min={0}
                    precision={8}
                    onInput={(val) => this.updateCol(val, row, 'productQuantity')}
                  ></InputNumberAd>,
                ];
              },
            },
          },
          {
            field: 'businessContractUnitPrice1',
            title: '合同价格',
            align: 'center',
            children: [
              {
                field: 'businessContractUnitPrice',
                title: '合同单价',
                width: 150,
                editRender: {
                  props: {
                    clearable: true,
                    // placeholder: '请输入合同单价',
                    disabled: true,
                  },
                },
                slots: {
                  default: ({ row }) => {
                    return [<span>{row['businessContractUnitPrice']}</span>];
                  },
                  edit: ({ row }) => {
                    return [
                      <InputNumberAd
                        value={row['businessContractUnitPrice']}
                        max={999999999.999999}
                        min={0}
                        precision={6}
                        disabled={true}
                      ></InputNumberAd>,
                    ];
                  },
                },
              },
              {
                field: 'businessContractTotalAmount',
                title: '价税合计金额',
                width: 150,
                editRender: {
                  name: 'ElInput',
                  props: {
                    clearable: true,
                    placeholder: '请输入价税合计金额',
                    // disabled: true,
                  },
                },
                slots: {
                  default: ({ row }) => {
                    return [<span>{row['businessContractTotalAmount']}</span>];
                  },
                  edit: ({ row }) => {
                    return [
                      <InputNumberAd
                        value={row['businessContractTotalAmount']}
                        max={999999999.999999}
                        min={0}
                        precision={6}
                        onInput={(val) => this.updateCol(val, row, 'businessContractTotalAmount')}
                      ></InputNumberAd>,
                    ];
                  },
                },
              },
              {
                field: 'businessContractTaxAmount',
                title: '税额',
                width: 150,
                editRender: {
                  name: 'ElInput',
                  props: {
                    clearable: true,
                    placeholder: '请输入税额',
                    disabled: true,
                  },
                },
              },
              {
                field: 'businessContractPureAmount',
                title: '净值',
                width: 150,
                editRender: {
                  name: 'ElInput',
                  props: {
                    clearable: true,
                    placeholder: '请输入净值',
                    disabled: true,
                  },
                },
              },
            ],
          },
          {
            field: 'isFixedPrice',
            title: '是否定价',
            width: 150,
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
              options: [
                {
                  label: '是',
                  value: '1',
                },
                {
                  label: '否',
                  value: '0',
                },
              ],
              events: {
                input: (obj) => this.updateCol(obj.row['isFixedPrice'], obj.row, 'isFixedPrice'),
              },
            },
          },
          {
            field: 'storageName',
            title: '仓库',
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                placeholder: '请输入仓库',
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['storageName']}</span>];
              },
              // selectCompanyCode: this.companyCode || this.userInfo.companyCode,
              edit: ({ row }) => {
                return [
                  <SearchTable
                    searchType="warehouse"
                    isMultiple={true}
                    isFixed={false}
                    extraData={{
                      currentStatus: 'ZT03',
                      contractCategory: 'purchase',
                      adminFlag: 2,
                      selectCompanyCode: this.companyCode || this.userInfo.companyCode,
                    }}
                    currentValue={row['storageName']}
                    checkRowKeys={[row['productNo']]}
                    onInput={(val) => this.chooseTable(val, row, 'storageName')}
                  ></SearchTable>,
                ];
              },
            },
          },
          {
            field: '',
            title: '变动价格',
            width: 150,
            align: 'center',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                placeholder: '请输入变动价格',
              },
            },
            children: [
              {
                field: 'businessChangeUnitPrice',
                title: '变动单价',
                width: 150,
                editRender: {
                  name: 'ElInput',
                  props: {
                    clearable: true,
                    placeholder: '请输入变动单价',
                    disabled: true,
                  },
                },
                slots: {
                  default: ({ row }) => {
                    return [
                      <div>
                        <span>{row['businessChangeUnitPrice']}</span>
                        {this.isShowVariablePriceIcon && row['isFixedPrice'] == '0' && (
                          <i
                            class="el-icon-edit-outline icon-btn"
                            onClick={(val) =>
                              this.clickBusinessOpenDialog(val, row, 'businessChangeUnitPrice')
                            }
                          ></i>
                        )}
                      </div>,
                    ];
                  },
                  edit: ({ row }) => {
                    return [<span>{row['businessChangeUnitPrice']}</span>];
                  },
                },
              },
              {
                field: 'businessChangeTotalAmount',
                title: '价税合计金额',
                width: 150,
                editRender: {
                  name: 'ElInput',
                  props: {
                    clearable: true,
                    placeholder: '请输入价税合计金额',
                    disabled: true,
                  },
                },
              },
              {
                field: 'businessChangeTaxAmount',
                title: '税额',
                width: 150,
                editRender: {
                  name: 'ElInput',
                  props: {
                    clearable: true,
                    placeholder: '请输入税额',
                    disabled: true,
                  },
                },
              },
              {
                field: 'businessChangePureAmount',
                title: '净值',
                width: 150,
                editRender: {
                  name: 'ElInput',
                  props: {
                    clearable: true,
                    placeholder: '请输入净值',
                    disabled: true,
                  },
                },
              },
            ],
          },
          {
            field: 'priceConfirmDate',
            title: '价格确定时间',
            width: 150,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                placeholder: '请选择价格确定时间',
                disabled: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['priceConfirmDate']}</span>];
              },
              edit: ({ row }) => {
                return [<span>{row['priceConfirmDate']}</span>];
              },
            },
          },
          {
            field: 'priceIdentity',
            title: '价格标识',
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                placeholder: '请输入价格标识',
              },
            },
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {row['priceIdentity'] >= 0
                      ? row['priceIdentity'] == 1
                        ? '已定价'
                        : '未定价'
                      : ''}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <span>
                    {row['priceIdentity'] >= 0
                      ? row['priceIdentity'] == 1
                        ? '已定价'
                        : '未定价'
                      : ''}
                  </span>,
                ];
              },
            },
          },
          {
            field: 'unitName',
            width: 150,
            title: '单位',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                placeholder: '请输入单位',
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['unitName']}</span>];
              },
              edit: ({ row }) => {
                return [<span>{row['unitName']}</span>];
              },
            },
          },
          {
            field: 'taxRate',
            title: '增值税',
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['taxRate']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['taxRate']}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.updateCol(val, row, 'taxRate')}
                  ></InputNumberAd>,
                ];
              },
            },
          },
        ];
      },
    },
    mounted() {
      this.getCompany();
    },
    methods: {
      clickProductDetailDialog(val, row, fieldName) {
        // 点击打开编辑价格弹框
        console.log(val, row, fieldName);
        this.$refs.productDescDialogRef.openModal(row);
      },
      clickBusinessOpenDialog(val, row, fieldName) {
        console.log(val, row, fieldName);
        this.$refs.businessDialogRef.openModal(row, this.detailPageData.pricingRule);
      },
      // 关闭的时候数据校验
      closeEditTableHandler() {
        console.log(this.getTableData(), '???');
        this.$emit('closeTableHandler', this.getTableData());
      },
      // 刷新表格数据
      updateProduct(obj) {
        console.log(obj, '更新');
        if (obj.prop == 'priceChange') {
          let row = obj.val;
          const productList = this.$refs.xTableRef.getTableData().fullData;
          productList.map((item) => {
            if (item.id == row.id) {
              item.businessChangeUnitPrice = row.businessChangeUnitPrice;
              item.priceConfirmDate = row.priceConfirmDate;
              item.priceIdentity = row.priceIdentity;
              item.businessChangeTaxAmount = row.businessContractTaxAmount;
              item.version = row.version;
              item.isPricingRecord = row.isPricingRecord;
              item.avgUnitPrice = row.avgUnitPrice;
              item.variablePrice = row.temporaryPrice;
              // 调用变动单价计算
              item['businessChangeTotalAmount'] = this.computedBusinessChangeTotalAmount(row); // 变动单价中 - 价税合计金额
              // item['businessChangePureAmount'] = this.computedBusinessChangePureAmount(row); // 变动单价中 - 净值
              item['businessChangeTaxAmount'] = this.computedBusinessChangeTaxAmount(row); // 变动单价中 - 税额
              const businessChangePureAmount =
                item['businessChangeTotalAmount'] - item['businessChangeTaxAmount'];
              item['businessChangePureAmount'] = businessChangePureAmount
                ? businessChangePureAmount.toFixed(6)
                : 0; // 变动单价中 - 净值
            }
          });
          // 更新表格数据
          this.$refs.xTableRef.reloadData(productList);
        }
      },
      // 表格底部
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            // 不定价
            if (['isFixedPrice'].includes(column.property)) {
              let result = true;
              data.map((item) => {
                if (!item.isFixedPrice) result = false;
              });
              this.$emit('getAmount', { isDisabledPricingRule: result });
            }
            // 合同总额
            if (['businessContractTotalAmount'].includes(column.property)) {
              this.$emit('getAmount', {
                contractTotalAmount: Number(
                  data.reduce((cur, next) => cur + +next.businessContractTotalAmount, 0)
                ).toFixed(6),
              });
            }
            if (['productQuantity'].includes(column.property)) {
              // 获取表格的底部合计采购数量
              let purchaseQuantity = data.reduce((cur, next) => cur + +next.productQuantity, 0);
              // if (['businessContractTotalAmount'].includes(column.property)) {
              //   console.log("合计金额")
              this.$emit('getAmount', { purchaseQuantity: Number(purchaseQuantity).toFixed(8) });
              // }
              return Number(purchaseQuantity).toFixed(8);
            }
            return '-';
          }),
        ];
      },
      handleSelectionChange(row) {
        this.selectionList = row.selection;
      },
      // 选择商品的时候
      chooseTable(val, row, filed) {
        console.log(val, row, filed, '===');
        if (filed == 'productDesc') {
          const product = val[0];
          if (product) {
            // row.productNo = product.parentProductNo;
            if (product?.productDetailCode && product?.productDetailCode.length != 0) {
              row['productNo'] = product?.productDetailCode;
            } else {
              row['productNo'] = product?.parentProductNo;
            }
            row.productDesc = product.productChName;
            row.unit = product.basicUnit || null;
            row.unitName = product.basicUnitName || null;
            row.customsId = product.customsId || null;
            row.taxRate = product.valueAddedTaxRate || 0;
            row.taxCode =
              this.$route.query.contractCategory == 'sales'
                ? product.salesTaxCode
                : product.valueAddedTaxCode;
            row.taxName = row.taxCode
              ? this.addedTaxRateOptions?.find((options) => {
                  return row.taxCode == options.taxCode;
                })?.taxName
              : '';
            row.valueAddedTaxRate = product.salesTaxRate || null;
            // 进口普通关税率
            row.importNormalTariffRate = product.importNormalTariffRate || null;
            // 单独处理生成销售合同时候的合同标
            row['contractMatterName'] = product?.productChName;
            if (product?.productDetailCode && product?.productDetailCode.length != 0) {
              row['contractMatter'] = product?.productDetailCode;
            } else {
              row['contractMatter'] = product?.parentProductNo;
            }
            if (product?.detailProductModel && product?.detailProductModel.length != 0) {
              row['norms'] = product?.detailProductModel;
            }
            row['stuff'] = product?.detailProductMaterial ?? '';
            //出口 转口 税率取出口退税率   其他是消费税率
            if (this.tradeType != '') {
              if (this.$route.query.contractCategory == 'sales') {
                row.consumptionTaxRate = product.salesTaxRate;
                row.taxRefundRate = product.taxRefundRate;
                row.taxRate = product.salesTaxRate;
                //销售-- 销项税码
                if (this.tradeType == 'MY04' || this.tradeType == 'MY03') {
                  row.consumptionTaxRate = 0;
                  //销售 -出口  04 转口 03 // 采购 -进口02
                }
              } else {
                row.valueAddedTaxRate = product.valueAddedTaxRate;
                row.taxRate = product.valueAddedTaxRate;
                //采购 --进项税码
                if (this.tradeType == 'MY03' || this.tradeType == 'MY02') {
                  row.valueAddedTaxRate = 0;
                  //采购 -转口 -进口02
                  row.importNormalTariffRate = product.importNormalTariffRate; //importNormalTariffRate
                }
              }
            }
          }
        } else if (filed == 'storageName') {
          const rowData = val[0];
          // 如果是仓库的时候  storageCode  storageName
          row['storageNo'] = rowData?.storageCode;
          row['storageName'] = rowData?.storageName;
        }
      },
      // 更新列
      updateCol(val, row, field) {
        console.log(field, '当前字段', val);
        if (field == 'isFixedPrice') {
          row['isFixedPrice'] = val;
          row['priceIdentity'] = val;
        } else if (
          field == 'taxRate' ||
          field == 'businessContractTotalAmount' ||
          // field == 'businessContractUnitPrice' ||
          field == 'productQuantity'
        ) {
          row[field] = val;
          console.log('改变了', field);

          if (field == 'taxRate') {
            // 增值税
            if (val > 1 || val < 0) {
              this.$message.error('增值税只能是0-1之间的数值');
              row['taxRate'] = 0;
            }
          }
          //需求变更3910 通过价税合计金额反推单价
          row['businessContractUnitPrice'] = this.computedBusinessContractUnitPrice(row);
          row['businessContractPureAmount'] = this.computedBusinessContractPureAmount(row); // 净值
          row['businessContractTaxAmount'] = this.computedBusinessContractTaxAmount(row); // 税额

          // row['businessContractTotalAmount'] = this.computedBusinessContractTotalAmount(row); // 价税合计金额
          row['variablePrice'] = row['businessContractUnitPrice'];
          row['businessChangeUnitPrice'] = row['businessContractUnitPrice'];
          row['businessChangeTaxAmount'] = row['businessContractTaxAmount'];
          // row['businessChangeTotalAmount'] = this.computedBusinessChangeTotalAmount(row); // 变动单价中 - 价税合计金额
          const businessChangeTotalAmount = row['businessContractTotalAmount'] - 0;
          console.log('typeof(businessChangeTotalAmount)', typeof businessChangeTotalAmount);
          row['businessChangeTotalAmount'] = businessChangeTotalAmount
            ? businessChangeTotalAmount.toFixed(6)
            : 0; // 变动单价中 - 价税合计金额
          row['businessChangeTaxAmount'] = this.computedBusinessChangeTaxAmount(row); // 变动单价中 - 税额
          // row['businessChangePureAmount'] = this.computedBusinessChangePureAmount(row); // 变动单价中 - 净值
          const businessChangePureAmount =
            row['businessChangeTotalAmount'] - row['businessChangeTaxAmount'];
          row['businessChangePureAmount'] = businessChangePureAmount
            ? businessChangePureAmount.toFixed(6)
            : 0; // 变动单价中 - 净值
        }
      },
      // 新增一行
      async addNewRowHandler() {
        // if (!['0', '1'].includes(this.isRestrict) || ![0, 1].includes(this.isRestrict)) {
        // }
        if (this.isRestrict != 0 && this.isRestrict != 1) {
          this.$message.error('请先选择是否定量');
          return;
        }
        const $table = this.$refs.xTableRef;
        const { row } = await $table.insertAt(
          { priceConfirmDate: formatDate(new Date(), true), isFixedPrice: '0' },
          0
        );
        await $table.setActiveRow(row);
      },
      // 删除行
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.orderDetailDelIds = [...this.orderDetailDelIds, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
      },
      // 获取表格数据
      getValidateTableData() {
        return new Promise((resolve, reject) => {
          const $table = this.$refs.xTableRef;
          const tableData = $table.getTableData().fullData;
          $table.validate((valid) => {
            if (valid && tableData.length) {
              const newData = tableData.map((item, index) => {
                if (this.isRestrict == '1' && item.productQuantity == 0) {
                  this.$message.error('当前属于限购，采购数量不能为0');
                  reject({ orderDetailList: [], orderDetailDelIds: [] });
                  return {};
                }
                return {
                  ...item,
                  priceConfirmDate: item.priceConfirmDate,
                  businessChangeUnitPrice: item.variablePrice,
                  variablePrice: null,
                  contractDetailNo: index + 1,
                  isFixedPrice: item.isFixedPrice + '',
                  taxRate: item.taxRate ? item.taxRate : 0,
                };
              });
              resolve({
                orderDetailList: newData,
                orderDetailDelIds: [...this.orderDetailDelIds],
              });
            } else {
              this.$message.error('请填写表格数据');
              reject({ orderDetailList: [], orderDetailDelIds: [] });
            }
          });
        });
      },
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData.map((item) => {
          return {
            ...item,
            isFixedPrice: item?.isFixedPrice + '',
            businessChangeUnitPrice: item?.businessChangeUnitPrice
              ? item?.businessChangeUnitPrice
              : item?.businessContractUnitPrice,
          };
        });
      },
      // 获取当前登陆人下面的所有公司数据
      async getCompany() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        this.$axios.post(API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            // 获取公司下拉
            let companyList = res.data.data.personCompanyInfo || [];
            this.companyList = companyList.map((item) => {
              return item?.personCompanyCode;
            });
          }
        });
      },
    },
    watch: {
      // 表格数据反填到表格中
      orderDetailList: {
        handler(val) {
          if (val && Array.isArray(val)) {
            this.fullTableData(val);
          }
        },
        immediate: true,
      },
      detailPageData: {
        handler(val) {
          if (val?.contractStatus) {
            console.log(val?.contractStatus, '监听当前状态');
            // TODO 这块需求未全面确定，先一个状态一个状态判断
            const currentContractStatus = val?.contractStatus; // 'ZT021';
            if (currentContractStatus == 'ZT02') {
              // 审批中
              this.editConfig = {};
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT03') {
              // 已生效
              this.editConfig = {};
              this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT07') {
              // 已关闭状态表格不能编辑按钮没有
              this.editConfig = {};
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT021') {
              // 修订审批中
              this.editConfig = {};
              this.isShowVariablePriceIcon = true;
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT021') {
              // 审批修订中
              this.editConfig = {};
              this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT025') {
              // 删除审批中
              this.editConfig = {};
              this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT024') {
              // 生效审批中
              this.editConfig = {};
              this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT022') {
              // 撤回审批中
              this.editConfig = {};
              this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT023') {
              // 关闭审批中
              // 撤回审批中
              this.editConfig = {};
              this.isShowVariablePriceIcon = true; // 显示可以修改变动单价的小图标
              this.isHiddenTopBtn = true;
            } else if (currentContractStatus == 'ZT061') {
              // 修订中,部分控件要禁止
              this.currentDisabledFiledList = [
                'materialType',
                'productQuantity2',
                'isFixedPrice',
                'priceConfirmDate',
                'priceIdentity',
                'variablePrice',
                'businessChangeUnitPrice',
                'shipmentPlace',
                'destination',
              ];
            } else if (currentContractStatus == 'ZT051') {
              // 修改已驳回,部分控件要禁止
              this.currentDisabledFiledList = [
                'materialType',
                'productQuantity2',
                'isFixedPrice',
                'priceConfirmDate',
                'priceIdentity',
                'variablePrice',
                'businessChangeUnitPrice',
                'shipmentPlace',
                'destination',
              ];
            } else {
              console.log('等待处理');
            }

            if (this.$route.query.isCopy) {
              this.editConfig = { trigger: 'click', mode: 'row' };
              this.isHiddenTopBtn = false;
            }
          }
        },
      },
    },
    components: {
      BusinessDialog,
      ProductDescDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .table {
    ::v-deep .el-date-editor {
      width: 100% !important;
    }
  }

  .table {
    ::v-deep {
      .vxe-body--column .vxe-cell {
        position: relative;
      }
    }
    .icon-btn {
      cursor: pointer;
      position: absolute;
      font-size: 16px;
      top: 5px;
      right: 6px;
      color: rgb(98, 153, 254);
    }
  }
</style>
